module.exports = __webpack_public_path__ + "static/Osano-0cefa6de807415749d6664e41796342c.jpg";